import { render } from "./Ball.vue?vue&type=template&id=a89601ca&scoped=true"
import script from "./Ball.vue?vue&type=script&lang=js"
export * from "./Ball.vue?vue&type=script&lang=js"

import "./Ball.vue?vue&type=style&index=0&id=a89601ca&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89601ca"]])

export default __exports__